PopOverAdView = require 'views/ads/pop-over-ad-view'
getExperiment = require 'lib/experiments/simple-test'

module.exports = class BusinessClassPopOverAdView extends PopOverAdView
  className: 'pop-over-ad business-class-ad'

  iconClass: ->
    'business-class-mark'

  click: ->
    super
    adsLayoutExperimentEnabled = getExperiment('adsLayout').get('enabled')

    if !adsLayoutExperimentEnabled
      window.open('/business-class', '_blank')



// WEBPACK FOOTER //
// ./app/scripts/views/ads/business-class-pop-over-ad-view.coffee